// NewKBBoard-BoardLayout.js
import React from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { Flex, Box, Spinner, Text } from '@chakra-ui/react';
import NewKBColumn from './NewKBColumn'; // Assuming NewKBColumn is in the same directory
import { STAGE_ORDER } from '../utils/NewKBConstants'; // Adjust path if needed

const NewKBBoardLayout = ({
  stages,
  filteredLeads,
  onDragEnd,
  areAllStagesLoaded,
  isDragContextReady
}) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Flex
        direction="row"
        overflowX="auto"
        overflowY="hidden"
        pb={1}
        width="100%"
        height="calc(100vh - 130px)" // Adjusted height calculation might be needed
        alignItems="stretch"
        justifyContent="flex-start"
        sx={{
          '&::-webkit-scrollbar': {
            height: '8px',
            borderRadius: '8px',
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
          },
          '&::-webkit-scrollbar-thumb': {
            borderRadius: '8px',
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
          },
        }}
      >
        {/* Render columns if stages are loaded */}
        {stages.length > 0 && stages.map((stage) => (
          <NewKBColumn
            key={stage._id}
            stage={stage}
            filteredLeads={filteredLeads.filter(lead => lead.stage === stage._id)}
            // Pass dragDisabled based on context readiness
            dragDisabled={!areAllStagesLoaded || !isDragContextReady}
          />
        ))}

        {/* Render placeholder columns if stages are not yet loaded */}
        {stages.length === 0 && STAGE_ORDER.map((stageId) => (
          <Box
            key={stageId}
            minW="300px"
            maxW="300px"
            mx={2}
            borderWidth="1px"
            borderRadius="md"
            bg="gray.100"
            p={3}
            h="150px" // Example height for placeholder
          >
            <Spinner size="sm" />
            <Text mt={2}>Loading stage...</Text>
          </Box>
        ))}
      </Flex>
    </DragDropContext>
  );
};

export default NewKBBoardLayout;